import { useSelector } from "react-redux";
import SwipeHint from "./SwipeHint";

function SkillsView({ active }) {
  const { skills } = useSelector((store) => store.app);
  const projectSkillsDivs = Object.keys(skills).map((skill, index) => (
    <div
      key={index}
      className="h-4 px-1 w-max mr-1.5 mt-1.5 font-medium skill-label text-[0.6rem] min-w-[25px] text-black flex flex-col justify-center items-center"
    >
      {skill}
    </div>
  ));
  return (
    <div className="h-full w-screen flex flex-col">
      <div className="w-full h-[70%] pt-2 px-2 flex flex-col">
        <div className="text-white text-sm">
          Here's Some Tech I'm Familiar With:
        </div>
        <div className="flex flex-row w-full grow overflow-y-auto flex-wrap thin-scrollbar">
          {projectSkillsDivs}
        </div>
      </div>
      {active && <SwipeHint />}
    </div>
  );
}

export default SkillsView;
